// @ts-strict-ignore
import { PageContext, PostType, ProfileTab, Connections } from 'src/constants/types';
import { getEnumKeyByEnumValue } from 'src/utils/dataStructure/enumStructures';
import WithErrorHandling, { RequestError } from 'src/components/hoc/withErrorHandling';
import ProfilePage, { props } from 'src/modules/user/profile/profilePage';
import { fetchProfileForUsername, setCurrentTab, fetchUserPosts, fetchConnections } from 'src/modules/user/profile/actions';
const Page = ({
  username
}: props) => <ProfilePage username={username} data-sentry-element="ProfilePage" data-sentry-component="Page" data-sentry-source-file="profile.tsx" />;
Page.getInitialProps = async ({
  store: {
    dispatch,
    getState
  },
  query: {
    username,
    page
  }
}: PageContext) => {
  if (!getState().context.currentUser) {
    throw new RequestError('This page is not available to visitors', 401);
  }
  await dispatch(fetchProfileForUsername(username));
  const {
    profileError,
    profileUser
  } = getState().pages.profile;
  if (profileError || !profileUser.userId) {
    throw new RequestError('Error fetching profile', profileError?.status || 500);
  }
  let formattedPage;
  if (page) {
    formattedPage = page.toLowerCase();
    const validTab = getEnumKeyByEnumValue(ProfileTab, formattedPage);
    if (validTab) {
      await dispatch(setCurrentTab(formattedPage));
    } else {
      throw new RequestError('Page does not exist', 404);
    }
  } else {
    await dispatch(setCurrentTab(ProfileTab.About));
  }
  switch (formattedPage) {
    case ProfileTab.Replies:
      await dispatch(fetchUserPosts(profileUser.userId, PostType.Reply));
      break;
    case ProfileTab.Connections:
      await dispatch(fetchConnections(profileUser.userId, Connections.Followers));
      break;
    case ProfileTab.Posts:
    default:
      await dispatch(fetchUserPosts(profileUser.userId, PostType.Post));
      break;
  }
  return {
    username
  };
};
export default WithErrorHandling(Page);